import { linear } from 'svelte/easing';
import {
  Animation,
  animationSpeed,
  getTranslate,
  SPRING,
} from './utils.svelte';
import { springIn } from './springs';
import type { GameType } from '~/types';

export const flipAnimation = new Animation(160);
export const shuffling = $state<{ current: boolean }>({ current: false });
export const collapsing = $state<{ current: boolean }>({ current: false });

export function flip(
  node: HTMLElement,
  { from, to }: { from: DOMRect; to: DOMRect },
  args?: { mode: GameType },
) {
  const [x0, y0] = getTranslate(node);
  const style = getComputedStyle(node);
  const [ox, oy] = style.transformOrigin.split(' ').map(parseFloat);
  const dx = from.left + (from.width * ox) / to.width - (to.left + ox);
  const dy = from.top + (from.height * oy) / to.height - (to.top + oy);
  const d = Math.sqrt(dx ** 2 + dy ** 2);
  const slowdown = Number(shuffling.current);
  const spring = animationSpeed.spring / (1 + slowdown);

  const bouncy = !(args?.mode === 'classic' || !collapsing.current);

  const params = {
    stiffness: bouncy ? 0.15 : 0.2,
    damping: bouncy ? 0.6 : 1,
    fps: spring,
    precision: 1,
  };
  const { duration, tickToValue } = springIn(d, 0, params);
  const delay = slowdown * y0;
  flipAnimation.queue(duration + delay + 500 * slowdown);
  return {
    delay,
    duration,
    easing: linear,
    css: (t: number, u: number) => {
      const delta = tickToValue(t) / d;
      const x = delta * dx;
      const y = delta * dy;
      const sx = 1 - delta + (delta * from.width) / to.width;
      const sy = 1 - delta + (delta * from.height) / to.height;
      return `translate: none; transform: translate3d(${x0 + x}px, ${y0 + y}px, 0) scale(${sx}, ${sy});`;
    },
  };
}
